/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { ContentHeader, Loader } from '@components';
import { AiOutlineDelete } from 'react-icons/ai';
import { toast } from 'react-toastify';
import Select from 'react-select';
import makeAnimated from 'react-select/animated';
import { Modal } from 'react-bootstrap';
import { FcDocument } from 'react-icons/fc';
import { useParams } from 'react-router-dom';
import Button from 'react-bootstrap/Button';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import { getProjectById } from '../../services/project';
import { getProjectFilesById } from '../../services/project';
import { getUserPermission } from '../../utils/helpers';
import { logoutUser } from '@app/store/reducers/auth';
import { deleteFile } from '@app/services/docs';
import { updateFile } from '@app/services/docs';
import FileUpload from '../../components/FileUpload';
import {
  getDocumentationFilesById,
  getDocumentationAllowedOnlyDeveloper,
  getSingleProjectForDeveloper,
  getProjectFilesForDeveloper
} from '../../services/project';
import { getAllUserNames } from '../../services/auth';
import { documentUpdateDocs } from '../../services/project';
import { updateDocAsset } from '@app/services/docs';
import handleStatus from '../../utils/ajax';
import { Link } from 'react-router-dom';
import '../../../src/index.css';
import Pagination from '../../components/pagination/index';
import { clearConfigCache } from 'prettier';

function DeletePopup({ handleClose, id, fetchProject }) {
  const delFile = async () => {
    const resp = await deleteFile(id);
    if (resp.status === 200) {
      toast.success('File has been deleted');
      fetchProject({});
      handleClose();
    }
  };
  return (
    <>
      <Modal show onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Delete File</Modal.Title>
        </Modal.Header>
        <Modal.Body>Are you sure to delete file ?</Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={delFile}>
            Yes
          </Button>
          <Button variant="secondary" onClick={handleClose}>
            No
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

function DocumentPermissionPopup({ users, project, handleClose, fetchProject }) {
  const [isPublic, setIsPublic] = useState(false);
  const animatedComponents = makeAnimated();
  const [show, setShow] = useState(false);
  const [disable, setDisable] = useState(false);
  const [assignedTo, setAssignedTo] = useState([]);
  const [documentId, setDocumentId] = useState('');
  // const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  if (documentId === '') {
    setDocumentId(project._id);
  }

  const onChangeFn = (val) => {
    if (val === 'true') {
      setIsPublic(true);
      setDisable(true);
      setAssignedTo(null);
    }
    if (val === 'false') {
      setIsPublic(false);
      setDisable(false);
    }
  };

  const handleSubmission = async (isPublic, assignedTo, documentId) => {
    if (isPublic === '') {
      toast('Pls enter some value');
      return;
    }
    if (isPublic === 'true') {
      setIsPublic(true);
    }
    if (isPublic === 'false') {
      setIsPublic(false);
    }

    const res = await documentUpdateDocs(isPublic, assignedTo, documentId);
    handleStatus(res.status, () => dispatch(logoutUser()), navigate);
    if (res.status === 200) {
      toast('Document update successfully');
      fetchProject();
      handleClose();
    }
  };

  React.useEffect(() => {
    // const assignedToUsers = users.filter((user) =>
    //   project.assignedTo.includes(user.value)
    // );
    const assignedToUsers = users.filter((user) => {
      const assignedUsers = project.assignedTo.find((val) => {
        if (val._id === user.value) {
          return user;
        }
      });
      return assignedUsers;
    });
    setAssignedTo(assignedToUsers);
    if (project.isPublic) {
      if (project.isPublic === 'Yes') {
        setIsPublic(true);
        setDisable(true);
        setAssignedTo(null);
      }
      if (project.isPublic === 'No') {
        setIsPublic(false);
        setDisable(false);
      }
    }
  }, []);

  return (
    <>
      <Modal show onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title> Add Activity</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Assigned To <br />
          <Select
            closeMenuOnSelect={false}
            components={animatedComponents}
            defaultValue={[]}
            isDisabled={disable}
            isMulti
            value={assignedTo}
            onChange={(e) => setAssignedTo(e)}
            options={users}
          />
          <br />
          Is public <br />
          <select
            className="form-control"
            name="leaveType"
            onChange={(e) => onChangeFn(e.target.value)}
            value={isPublic}
          >
            <option value={'true'}>Yes</option>
            <option value={'false'}>No</option>
          </select>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="primary"
            onClick={() => handleSubmission(isPublic, assignedTo, documentId)}
          >
            Assign
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

function FilePermissionPopup({ users, file, handleClose, fetchProject }) {
  const [isPublic, setIsPublic] = useState(false);
  const animatedComponents = makeAnimated();
  const [show, setShow] = useState(false);
  const [disable, setDisable] = useState(false);
  const [assignedTo, setAssignedTo] = useState([]);
  const [documentId, setDocumentId] = useState('');
  // const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  if (documentId === '') {
    setDocumentId(file._id);
  }

  const onChangeFn = (val) => {
    if (val === 'true') {
      setIsPublic(true);
      setDisable(true);
      setAssignedTo(null);
    }
    if (val === 'false') {
      setIsPublic(false);
      setDisable(false);
    }
  };

  const handleSubmission = async (isPublic, assignedTo, documentId) => {
    if (isPublic === '') {
      toast('Pls enter some value');
      return;
    }
    if (isPublic === 'true') {
      setIsPublic(true);
    }
    if (isPublic === 'false') {
      setIsPublic(false);
    }

    const res = await updateFile(isPublic, assignedTo, documentId);
    handleStatus(res.status, () => dispatch(logoutUser()), navigate);
    if (res.status === 200) {
      toast.success('File updated successfully');
      fetchProject();
      handleClose();
    }
  };

  React.useEffect(() => {
    // const assignedToUsers = users.filter((user) =>
    //   file.assignedTo.includes(user.value)
    // );
    const assignedToUsers = users.filter((user) => {
      const assignedUsers = file.assignedTo.find((val) => {
        if (val._id === user.value) {
          return user;
        }
      });
      return assignedUsers;
    });
    setAssignedTo(assignedToUsers);
    if (file.isPublic) {
      if (file.isPublic === 'Yes') {
        setIsPublic(true);
        setDisable(true);
        setAssignedTo(null);
      }
      if (file.isPublic === 'No') {
        setIsPublic(false);
        setDisable(false);
      }
    }
  }, []);

  return (
    <>
      <Modal show onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title> Add Activity</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Assigned To <br />
          <Select
            closeMenuOnSelect={false}
            components={animatedComponents}
            defaultValue={[]}
            isDisabled={disable}
            isMulti
            value={assignedTo}
            onChange={(e) => setAssignedTo(e)}
            options={users}
          />
          <br />
          Is public <br />
          <select
            className="form-control"
            name="leaveType"
            onChange={(e) => onChangeFn(e.target.value)}
            value={isPublic}
          >
            <option value={'true'}>Yes</option>
            <option value={'false'}>No</option>
          </select>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="primary"
            onClick={() => handleSubmission(isPublic, assignedTo, documentId)}
          >
            Assign
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

const AllProjects = () => {
  const { projectId } = useParams();
  const [project, setProject] = useState({});
  const [projectFiles, setProjectFiles] = useState([]);
  const [deleteFileId, setDeleteFileId] = useState('');
  const [projectName, setProjectName] = useState([]);
  const [showLoader, setShowLoader] = useState(false);
  const [showPermissionPopup, setShowPermissionPopup] = useState(false);
  const [showDeletePopup, setShowDeletePopup] = useState(false);
  const [showPermissionPopupFiles, setShowPermissionPopupFiles] =
    useState(false);
  const [permissionProjectInfo, setPermissionProjectInfo] = useState({});
  const [permissionFileInfo, setPermissionFileInfo] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const [postPerPage] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [totalRecordsOfFiles, setTotalRecordsOfFiles] = useState(0);
  const [users, setUsers] = React.useState([]);
  const navigate = useNavigate();

  const user = useSelector((state: any) => state.auth.currentUser);
  const dispatch = useDispatch();

  const fetchProject = async (pageno) => {
    if (getUserPermission(user) === 'admin') {
      setShowLoader(true);

      const resp = await getProjectById(projectId);
      handleStatus(resp.status, () => dispatch(logoutUser()), navigate);
      const result = await getProjectFilesById(projectId, pageno);
      handleStatus(result.status, () => dispatch(logoutUser()), navigate);
      const resultOfDocs = await getDocumentationFilesById(projectId, pageno);
      handleStatus(resultOfDocs.status, () => dispatch(logoutUser()), navigate);

      const resultOfUsers = await getAllUserNames();
      handleStatus(
        resultOfUsers.status,
        () => dispatch(logoutUser()),
        navigate
      );
      const resultActiveUser = resultOfUsers.data.data;

      if (resultActiveUser) {
        setUsers(
          resultActiveUser.map((user) => {
            return { value: user._id, label: user.name };
          })
        );
      }
      setProject(resp.data.data);
      setProjectFiles(result.data.data);
      setProjectName(resultOfDocs.data.data);
      setTotalRecords(resultOfDocs.data.totalRecords);
      setTotalRecordsOfFiles(result.data.totalRecords);
      setShowLoader(false);
    }

    if (getUserPermission(user) === 'developer' || getUserPermission(user) === 'seo') {
      setShowLoader(true);

      const resp = await getSingleProjectForDeveloper(projectId);
      handleStatus(resp.status, () => dispatch(logoutUser()), navigate);

      const result = await getProjectFilesForDeveloper(projectId, pageno);
      handleStatus(result.status, () => dispatch(logoutUser()), navigate);

      const resultOfDocs = await getDocumentationAllowedOnlyDeveloper(
        projectId,
        pageno
      );
      handleStatus(result.status, () => dispatch(logoutUser()), navigate);
      setProject(resp.data.data);
      setProjectFiles(result.data.data);
      setProjectName(resultOfDocs.data.data);
      setTotalRecords(resultOfDocs.data.totalRecords);
      setTotalRecordsOfFiles(result.data.totalRecords);

      setShowLoader(false);
    }
  };

  const showPermissionPopupFn = (projectInfo) => {
    setShowPermissionPopup(true);
    setPermissionProjectInfo(projectInfo);
  };

  const showDeletePopupFn = (id) => {
    setShowDeletePopup(true);
    setDeleteFileId(id);
  };

  const handleCloseDeletePopup = () => {
    setShowDeletePopup(false);
  };
  const showPermissionPopupOfFilesFn = (fileInfo) => {
    setShowPermissionPopupFiles(true);
    setPermissionFileInfo(fileInfo);
  };

  const handleClose = () => {
    setShowPermissionPopup(false);
    setPermissionProjectInfo({});
  };

  const handleClosePopupFile = () => {
    setShowPermissionPopupFiles(false);
    setPermissionFileInfo({});
  };
  useEffect(() => {
    fetchProject(currentPage);
  }, []);

  const fileName = (fileLink) => {
    const fileLinkName = fileLink.split('/');
    const fileName = fileLinkName[fileLinkName.length - 1];

    return fileName;
  };
  const paginate = (pageno) => {
    setCurrentPage(pageno);
    fetchProject(pageno);

    //setCurrentPage(pageno);
  };

  const callback = (nameOfFile, getHash) => {
    if (nameOfFile && getHash && getUserPermission(user) === 'admin') {
      const fileUploadFn = async () => {
        // const getId = val.split('/');
        //   const getFinalId = getId[getId.length - 1];
        const res = await updateDocAsset({
          projectId: projectId,
          fileHash: getHash,
          isPublic: false,
          assignedTo: [],
          fileName: nameOfFile
        });
        handleStatus(res.status, () => dispatch(logoutUser()), navigate);
        if (res.status === 200) {
          fetchProject();
        }
      };
      fileUploadFn();
    }
    if (nameOfFile && getHash && (getUserPermission(user) === 'developer' || getUserPermission(user) === 'seo') ) {
      const fileUploadFn = async () => {
        // const getId = val.split('/');
        //   const getFinalId = getId[getId.length - 1];
        const res = await updateDocAsset({
          projectId: projectId,
          fileHash: getHash,
          isPublic: true,
          assignedTo: [],
          fileName: nameOfFile
        });
        handleStatus(res.status, () => dispatch(logoutUser()), navigate);
        if (res.status === 200) {
          fetchProject();
        }
      };
      fileUploadFn();
    }
  };

  // if (project.projectName === undefined) {
  //   return <Loader title={'Daily'} />;
  // }

  return (
    <div>

      <ContentHeader title={project?.projectName}  path="/projects" />
      <section className="content">
        <div className="container-fluid">
          <div className="card">
            <div className="card-header card-header-of-project">
              <div className="title-project">
                <h3 className="card-title">Project Detail Page</h3>
              </div>
              <div className="create-doc">
                <Link
                  to={`/create-doc/${projectId}`}
                  className="btn btn-primary btn-sm mr-2"
                >
                  Create Document &nbsp; <i className="fas fa-pencil-alt"></i>
                </Link>
              </div>
            </div>
            <div className="card-body">
              <div className="col-12">
                <div className="card">
                  <div className="row">
                    <div className="col-12 col-md-12 col-lg-8 order-2 order-md-1">
                      <div className="row">
                        <div className="col-12 col-sm-4">
                          <div className="info-box bg-light">
                            <div className="info-box-content">
                              <span className="info-box-text text-center text-muted">
                                Estimated Hours
                              </span>
                              <span className="info-box-number text-center text-muted mb-0">
                                0 hrs
                              </span>
                            </div>
                          </div>
                        </div>
                        <div className="col-12 col-sm-4">
                          <div className="info-box bg-light">
                            <div className="info-box-content">
                              <span className="info-box-text text-center text-muted">
                                Total Hours spent
                              </span>
                              <span className="info-box-number text-center text-muted mb-0">
                                0 hrs
                              </span>
                            </div>
                          </div>
                        </div>
                        <div className="col-12 col-sm-4">
                          <div className="info-box bg-light">
                            <div className="info-box-content">
                              <span className="info-box-text text-center text-muted">
                                Running Hours
                              </span>
                              <span className="info-box-number text-center text-muted mb-0">
                                0 hr
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-12">
                          <h2>Assigned To</h2>
                          <div className="card-body table-responsive p-0">
                            <table className="table table-hover text-nowrap">
                              <thead>
                                <tr>
                                  <th>Id</th>
                                  <th>User Name</th>
                                  <th>Profile</th>
                                  <th>Active</th>
                                </tr>
                              </thead>
                              <tbody>
                                {project.assignedTo &&
                                  project.assignedTo.map((user, index) => {
                                    if (user.profile === '') {
                                      user.profile = '/img/default-profile.png';
                                    }
                                    return (
                                      <tr>
                                        <td>{index + 1}</td>
                                        <td>{user.name}</td>
                                        <td>
                                          <img
                                            className="img-circle img-bordered-sm"
                                            src={user.profile}
                                            alt="user image"
                                          />
                                        </td>
                                        <td>
                                          {user.deactivated ? 'No' : 'Yes'}
                                        </td>
                                      </tr>
                                    );
                                  })}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                      {/* Here to put the code*/}
                    </div>

                    <div className="col-12 col-md-12 col-lg-4 order-1 order-md-2">
                      <>
                        <div>
                          <h3 className="text-primary">
                            <i className="fas fa-paint-brush"></i> Project
                            Description
                          </h3>
                          <p className="text-muted">
                            {project.projectInformation}
                          </p>
                          <br />
                          <div className="text-muted">
                            <p className="text-sm">
                              Client Name
                              <b className="d-block">
                                {project.client &&
                                  getUserPermission(user) === 'admin'
                                  ? project.client.clientName
                                  : 'N/A'}
                              </b>
                            </p>
                          </div>

                          {/* <h5 className="mt-5 text-muted">Project files</h5>
                            <ul className="list-unstyled overflow-auto projectfiles">
                              {projectFiles.map((value, index) => {
                                return (
                                  <>
                                    <li>
                                      <Link to={'/file/' + value.fileHash}>
                                        <FcDocument />
                                        {value.fileName}
                                      </Link>
                                    </li>
                                  </>
                                );
                              })}
                            </ul> */}
                          <div className="text-center mt-5 mb-3">
                            <FileUpload callback={callback} />
                            <br />
                          </div>
                        </div>
                      </>
                    </div>
                  </div>
                  <Tabs>
                    <Tab eventKey="first" title="Documentation">
                      <div className="row">
                        <div className="col-12">
                          <div className="col-12">
                            {showLoader ? (
                              <Loader title={'Daily'} />
                            ) : (
                              <div className="card-body table-responsive p-0">
                                <table className="table table-hover text-nowrap">
                                  <thead>
                                    <tr>
                                      <th style={{ width: '20%' }}>S.No.</th>
                                      <th style={{ width: '30%' }}>
                                        Document Name{' '}
                                      </th>
                                      <th>Is Public</th>
                                      <th>Assigned To</th>
                                      <th>View</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {projectName.map((value, index) => {
                                      if (value.isPublic === false) {
                                        value.isPublic = 'No';
                                      }
                                      if (value.isPublic === true) {
                                        value.isPublic = 'Yes';
                                      }
                                      if (value.isPublic === undefined) {
                                        value.isPublic = 'Not Declared';
                                      }
                                      if (
                                        getUserPermission(user) === 'developer' || getUserPermission(user) === 'seo'
                                      ) {
                                        return (
                                          <tr key={index}>
                                            <td>{index + 1}</td>
                                            <td>
                                              <span>
                                              {value.documentationName}
                                              </span>
                                              {/* <Link
                                                to={`/view-doc/${value._id}`}
                                              >
                                                {value.documentationName}
                                              </Link> */}
                                            </td>
                                            <td>{value.isPublic}</td>
                                            <td>
                                              {' '}
                                              {value.assignedTo.length > 0
                                                ? value.assignedTo.map(
                                                  (val) => {
                                                    return val.name + ',';
                                                  }
                                                )
                                                : 'N/A'}
                                            </td>
                                            <td>
                                              <Link
                                                to={`/view-doc/${value._id}`}
                                                className="btn btn-primary btn-sm mr-2"
                                              >
                                                <i className="fas fa-eye"></i>
                                              </Link>
                                              <Link
                                                to={`/update-doc/${value._id}`}
                                                className="btn btn-primary btn-sm mr-2"
                                              >
                                                <i className="fas fa-pencil-alt"></i>
                                              </Link>

                                              {/* <Link
                                                to="#"
                                                className="btn btn-primary btn-sm mr-2"
                                                onClick={() =>
                                                  showPermissionPopupFn(value)
                                                }
                                              >
                                                <i className="fas fa-cog"></i>
                                              </Link> */}
                                            </td>
                                          </tr>
                                        );
                                      }
                                      if (getUserPermission(user) === 'admin') {
                                        return (
                                          <tr>
                                            <td>{index + 1}</td>
                                            <td>
                                              <Link
                                                to={`/view-doc/${value._id}`}
                                              >
                                                {value.documentationName}
                                              </Link>
                                            </td>
                                            <td>{value.isPublic}</td>
                                            <td>
                                              {value.assignedTo.length > 0
                                                ? value.assignedTo.map(
                                                  (val) => {
                                                    return val.name + ',';
                                                  }
                                                )
                                                : 'N/A'}
                                            </td>
                                            <td>
                                              <Link
                                                to={`/view-doc/${value._id}`}
                                                className="btn btn-primary btn-sm mr-2"
                                              >
                                                <i className="fas fa-eye"></i>
                                              </Link>
                                              <Link
                                                to={`/update-doc/${value._id}`}
                                                className="btn btn-primary btn-sm mr-2"
                                              >
                                                <i className="fas fa-pencil-alt"></i>
                                              </Link>

                                              <Link
                                                to="#"
                                                className="btn btn-primary btn-sm mr-2"
                                                onClick={() =>
                                                  showPermissionPopupFn(value)
                                                }
                                              >
                                                <i className="fas fa-cog"></i>
                                              </Link>
                                            </td>
                                          </tr>
                                        );
                                      }
                                    })}

                                    {showPermissionPopup && (
                                      <DocumentPermissionPopup
                                        handleClose={handleClose}
                                        project={permissionProjectInfo}
                                        users={users}
                                        fetchProject={fetchProject}
                                      />
                                    )}
                                  </tbody>
                                </table>
                                <Pagination
                                  postsPerPage={postPerPage}
                                  totalPosts={totalRecords}
                                  paginate={paginate}
                                  currentPage={currentPage}
                                ></Pagination>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </Tab>
                    <Tab eventKey="Second" title="Files">
                      <div className="card-body table-responsive p-0">
                        {showLoader ? (
                          <Loader title={'Daily'} />
                        ) : (
                          <table className="table table-hover text-nowrap">
                            <thead>
                              <tr>
                                <th style={{ width: '10%' }}>S.No.</th>
                                <th style={{ width: '20%' }}>File Name </th>
                                <th>Is Public</th>
                                <th style={{ width: '20%' }}>Assigned To</th>
                                <th>Uplaoded By</th>
                                <th>Actions</th>
                              </tr>
                            </thead>
                            <tbody>
                              {projectFiles.map((value, index) => {
                                if (value.isPublic === true) {
                                  value.isPublic = 'Yes';
                                }
                                if (value.isPublic === false) {
                                  value.isPublic = 'No';
                                }

                                if (getUserPermission(user) === 'admin') {
                                  return (
                                    <>
                                      <tr>
                                        <td>{index + 1}</td>
                                        <td>
                                          <Link to={'/file/' + value.fileHash}>
                                            <FcDocument />
                                            {value.fileName
                                              ? value.fileName.substring(
                                                0,
                                                20
                                              ) + '...'
                                              : 'N/A'}
                                          </Link>
                                        </td>
                                        <td>{value.isPublic}</td>
                                        <td>
                                          {' '}
                                          {value.assignedTo
                                            ? value.assignedTo.map((val) => {
                                              return val.name + ' ';
                                            })
                                            : 'N/A'}
                                        </td>
                                        <td>
                                          {value.uploadedBy
                                            ? value.uploadedBy.name
                                            : 'N/A'}
                                        </td>
                                        <td>
                                          <Link
                                            to={'/file/' + value.fileHash}
                                            target="_blank"
                                            className="btn btn-primary btn-sm mr-2"
                                          >
                                            <i className="fas fa-eye"></i>
                                          </Link>
                                          <Link
                                            to="#"
                                            className="btn btn-primary btn-sm mr-2"
                                            onClick={() =>
                                              showPermissionPopupOfFilesFn(
                                                value
                                              )
                                            }
                                          >
                                            <i className="fas fa-cog"></i>
                                          </Link>

                                          <Link
                                            to="#"
                                            onClick={() =>
                                              showDeletePopupFn(value._id)
                                            }
                                            className="btn btn-primary btn-sm mr-2 bg-danger border-danger"
                                          >
                                            <AiOutlineDelete />
                                          </Link>
                                        </td>
                                      </tr>
                                    </>
                                  );
                                }
                                if (getUserPermission(user) === 'developer' || getUserPermission(user) === 'seo') {
                                  return (
                                    <>
                                      <tr>
                                        <td>{index + 1}</td>
                                        <td>
                                          <Link to={'/file/' + value.fileHash}>
                                            <FcDocument />
                                            {value.fileName.substring(0, 8) +
                                              '...'}
                                          </Link>
                                        </td>
                                        <td>{value.isPublic}</td>
                                        <td>
                                          {' '}
                                          {value.assignedTo.length > 0
                                            ? value.assignedTo.map((val) => {
                                              return val.name + ' ';
                                            })
                                            : 'N/A'}
                                        </td>
                                        <td>{value.uploadedBy.name}</td>
                                        <td>
                                          <Link
                                            to={'/file/' + value.fileHash}
                                            target="_blank"
                                            className="btn btn-primary btn-sm mr-2"
                                          >
                                            <i className="fas fa-eye"></i>
                                          </Link>
                                          {/* <Link
                                            to={`/update-doc/${value._id}`}
                                            className="btn btn-primary btn-sm mr-2"
                                          >
                                            <i className="fas fa-pencil-alt"></i>
                                          </Link> */}
                                        </td>
                                      </tr>
                                    </>
                                  );
                                }
                              })}
                              {showDeletePopup && (
                                <DeletePopup
                                  handleClose={handleCloseDeletePopup}
                                  id={deleteFileId}
                                  fetchProject={fetchProject}
                                />
                              )}
                            </tbody>
                          </table>
                        )}

                        <Pagination
                          postsPerPage={postPerPage}
                          totalPosts={totalRecordsOfFiles}
                          paginate={paginate}
                          currentPage={currentPage}
                        ></Pagination>
                      </div>
                    </Tab>
                  </Tabs>
                  {showPermissionPopupFiles && (
                    <FilePermissionPopup
                      handleClose={handleClosePopupFile}
                      file={permissionFileInfo}
                      users={users}
                      fetchProject={fetchProject}
                    />
                  )}
                </div>
              </div>
              <div className="modal fade" id="modal-default">
                <div className="modal-dialog">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h4 className="modal-title">Default Modal</h4>
                      <button
                        type="button"
                        className="close"
                        data-dismiss="modal"
                        aria-label="Close"
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                    <div className="modal-body">
                      <p>One fine body&hellip;</p>
                    </div>
                    <div className="modal-footer justify-content-between">
                      <button
                        type="button"
                        className="btn btn-default"
                        data-dismiss="modal"
                      >
                        Close
                      </button>
                      <button type="button" className="btn btn-primary">
                        Save changes
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AllProjects;
